import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Trophy, Crown } from "lucide-react";
import { api } from "@/lib/api";
import { Avatar } from "./WalkieLayout";

const BOARDS = [["tippers", "Top tippers"], ["tipped", "Most tipped"], ["active", "Most active"], ["channels", "Popular channels"]];
const PERIODS = [["day", "Today"], ["week", "This week"], ["all", "All time"]];
const fmtSec = (s) => (s >= 3600 ? `${(s / 3600).toFixed(1)}h` : `${Math.round(s / 60)}m`);

export default function WalkieLeaderboard() {
  const [board, setBoard] = useState("tippers");
  const [period, setPeriod] = useState("week");
  const [rows, setRows] = useState(null);
  useEffect(() => { setRows(null); api.get("/walkie/leaderboard", { params: { board, period } }).then((r) => setRows(r.data.rows)).catch(() => setRows([])); }, [board, period]);
  const score = (r) => (board === "active" || board === "channels" ? fmtSec(r.score) + " talk time" : `${r.score} coins`);
  return (
    <div className="space-y-4" data-testid="walkie-leaderboard">
      <h1 className="font-black text-2xl flex items-center gap-2"><Trophy className="w-6 h-6 text-[#FFE300]" /> Leaderboards</h1>
      <div className="flex gap-2 overflow-x-auto pb-1">
        {BOARDS.map(([k, l]) => (
          <button key={k} onClick={() => setBoard(k)} data-testid={`walkie-board-${k}`}
            className={`shrink-0 text-xs font-bold px-3 py-1.5 rounded-full border ${board === k ? "border-[#FF2BD6] text-[#FF2BD6] bg-[#FF2BD6]/10" : "wt-line wt-muted"}`}>{l}</button>
        ))}
      </div>
      <div className="flex gap-2">
        {PERIODS.map(([k, l]) => (
          <button key={k} onClick={() => setPeriod(k)} data-testid={`walkie-period-${k}`}
            className={`text-xs font-bold px-3 py-1.5 rounded-full ${period === k ? "bg-[#00F0FF] text-black" : "wt-card wt-muted"}`}>{l}</button>
        ))}
      </div>
      {!rows ? <div className="wt-muted text-sm animate-pulse">Loading…</div> : rows.length === 0 ? <div className="wt-muted text-sm" data-testid="walkie-board-empty">No activity yet for this period.</div> : (
        <ol className="space-y-1.5">
          {rows.map((r, i) => (
            <li key={r.user_id || r.channel_id} data-testid={`walkie-board-row-${i}`}>
              <Link to={r.channel_id ? `/walkie/c/${r.channel_id}` : `/walkie/u/${r.user_id}`} className="wt-card rounded-xl px-3 py-2.5 flex items-center gap-3">
                <span className={`w-6 text-center font-black ${i < 3 ? "text-[#FFE300]" : "wt-muted"}`}>{i === 0 ? <Crown className="w-4 h-4 mx-auto" /> : i + 1}</span>
                {!r.channel_id && <Avatar p={r} size={32} />}
                <span className="flex-1 font-bold truncate">{r.channel_id ? `#${r.name}` : r.display_name}</span>
                <span className="text-xs font-black">{score(r)}</span>
              </Link>
            </li>
          ))}
        </ol>
      )}
      <p className="text-[10px] wt-muted">Talk time counts only when others are listening, up to a daily cap. Flagged or suspicious tips are excluded.</p>
    </div>
  );
}
